module.exports = __webpack_public_path__ + "static/img/14.22ccefd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/eng/14.png
// module id = kpv6
// module chunks = 0